import clsx from "clsx";

import {
  Show,
  Suspense,
  createEffect,
  createMemo,
  createSignal,
  on,
} from "solid-js";

import { Loading } from "@/components/Base/Loading/Loading";
// import { useDialog } from "@/components/Dialogs/useDialog.ts";
import { useEventListener } from "@/hooks/useEventListener";
import { useHeaderOpacityOnScroll } from "@/hooks/useScroll";
import { useViewportReflowFix } from "@/hooks/useViewportReflowFix";
import { overFlowFlagManager } from "@/lib/OverFlowFlag";
import { getRealPath } from "@/lib/language";
import { removeLocalePrefix } from "@/lib/urlUtils";
import { deviceInfo } from "@/stores/deviceStore";
import { sidebarStore } from "@/stores/sidebar";
import { userStore } from "@/stores/userStore";
import { FlowProps } from "@/types/base";
import { useLocation } from "@solidjs/router";

import Menu from "../../components/Common/Menu/Menu";
import AppDownloadBannerH5 from "./components/AppDownloadBanner";
import DownloadBanner from "./components/DownloadBanner";
import Footer from "./components/Footer";
import HomeHeader from "./components/Header/HomeHeader";
import BottomNavigation from "./components/Navigation/BottomNav";
import VerifyTip from "./components/VerifyTip";

export function H5LobbyLayout(props: FlowProps) {
  let scrollContainer!: HTMLDivElement;
  let bottomNavRef!: HTMLDivElement;

  const hiddenFooter = ["menu", "profile", "sports"];

  const [isOpen, setIsOpen] = createSignal(false);
  const [isOpenMask, setIsOpenMask] = createSignal(false);
  // -- 控制是否渲染下载横幅
  const [isOpenDownloadAppBar, setIsOpenDownloadAppBar] = createSignal(false);
  // const [downloadAppBarHeight, setDownloadAppBarHeight] = createSignal(0);

  // const { operateDialog } = useDialog();
  const location = useLocation();
  const kHeaderBarHeight = 57;
  const kDownloadBarHeight = 51;

  const isLogin = createMemo(() => userStore.isLogin);
  const currentPath = createMemo(() => removeLocalePrefix(location.pathname));

  useViewportReflowFix(bottomNavRef);

  useHeaderOpacityOnScroll();

  createEffect(
    on(
      createMemo(() => isOpenMask()),
      (v) => {
        if (v) {
          overFlowFlagManager.addFlag();
        } else {
          overFlowFlagManager.removeFlag();
        }
      },
    ),
  );

  // operateDialog("Minors18Popup", true);

  // createEffect(() => {
  //   document.body.style.overflow = isOpen() ? "hidden" : "auto";
  // });
  // createEffect(
  //   on(isOpenDownloadAppBar, (v) => {
  //     setDownloadAppBarHeight(v ? 51 : 0);
  //   }),
  // );
  const getTodayKey = () => {
    const d = new Date();
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  };
  createEffect(() => {
    const closedDate = localStorage.getItem("appDownloadBannerH5Closed");
    if (closedDate === getTodayKey()) {
      setIsOpenDownloadAppBar(false);
      return;
    }
    if (!isLogin()) {
      setIsOpenDownloadAppBar(false);
    } else if (currentPath() !== "/") {
      setIsOpenDownloadAppBar(false);
    } else if (deviceInfo.app || deviceInfo.pwa) {
      setIsOpenDownloadAppBar(false);
    } else if (deviceInfo.app_type === 0) {
      setIsOpenDownloadAppBar(true);
    }
  });

  // useEventListener(window, "scroll", () => {
  //   if (isLogin() && currentPath() === "/") {
  //     const current =
  //       window.scrollY !== undefined
  //         ? window.scrollY
  //         : document.documentElement.scrollTop || document.body.scrollTop || 0;
  //     setIsOpenDownloadAppBar(
  //       current < 51 && !(deviceInfo.app || deviceInfo.pwa),
  //     );
  //   }
  // });

  return (
    <div
      ref={scrollContainer}
      class={`h-full bg-[var(--colors-surface-bg-10)] ${deviceInfo.ios && deviceInfo.m_app == 10 ? "page-scroll-container" : ""}`}
    >
      <Show when={isOpenDownloadAppBar()} fallback={<></>}>
        <div class="fixed bottom-[76px] left-0 right-0 z-50 h-[68px] w-full">
          <AppDownloadBannerH5 />
        </div>
      </Show>

      <div class="fixed left-0 right-0 top-0 z-50">
        {/* 下载 */}
        {/* <Show when={isOpenDownloadAppBar()}>
          <div
            class="w-full overflow-hidden transition-[height] duration-300"
            style={{
              height: isVisibleDownloadAppBar()
                ? kDownloadBarHeight + "px"
                : "0px",
            }}
          >
            <DownloadBanner />
          </div>
        </Show> */}
        {/* <AppDownloadBannerH5 /> */}

        {/* 顶部导航 */}
        <div
          class={"bg-(--colors-surface-bg-8) font-['Alexandria']"}
          style={{
            height: kHeaderBarHeight + "px",
          }}
        >
          <HomeHeader
            isOpen={isOpen()}
            downloadAppBarHeight={0}
            onToggleOpen={(open: boolean) => {
              setIsOpen(open);
              console.error("open", open);
              if (open) setIsOpenMask(open);
            }}
          />
        </div>
      </div>
      <div
        class="h-full"
        style={{
          // "padding-top": `${!isOpenDownloadAppBar() ? 57 : downloadAppBarHeight() + 57}px`,
          "padding-top": "57px",
          "padding-bottom": "66px",
        }}
      >
        <Suspense
          fallback={
            <div
              style={{
                "min-height": `calc(100%-var(--header-height)}px)`,
              }}
            >
              <Loading />
            </div>
          }
        >
          {props.children}
          <Show
            when={
              !hiddenFooter.includes(
                getRealPath(useLocation().pathname).split("/")[0],
              )
            }
            fallback={<></>}
          >
            <Footer currentPath={useLocation().pathname} />
          </Show>
        </Suspense>
      </div>
      {/* <Cookies /> */}
      <VerifyTip />
      {/* 抽屉菜单 */}
      <div
        class={clsx(
          "translate-z-0 bg-(--colors-overlay-80) backdrop-blur-xs fixed z-[-1] box-border w-screen pl-1.5 opacity-0 transition-all duration-200 ease-linear will-change-transform",
          {
            "!z-1000 !opacity-100": isOpenMask(),
          },
        )}
        style={{
          top: "57px",
          height: `calc(100% - 57px)`,
        }}
        onClick={() => setIsOpen(false)}
      >
        <div
          class="translate-z-0 rounded-(--lg) bg-(--colors-surface-bg-9) p-(--core-spacing-2) absolute box-border h-full w-[236px] -translate-x-full overflow-auto transition-all duration-300 ease-linear will-change-transform"
          classList={{ "!translate-x-0": isOpen() }}
          onClick={(ev) => ev.stopPropagation()}
          onTransitionEnd={() => {
            if (!isOpen()) setIsOpenMask(false);
          }}
        >
          <Menu onClose={() => setIsOpen(false)} />
        </div>
      </div>
      <div
        class="fixed bottom-0 left-0 right-0 z-50"
        ref={(el) => (bottomNavRef = el)}
      >
        <BottomNavigation />
      </div>
    </div>
  );
}
